<template>
  <div class="container">
    <!-- 页面内容 -->
    <div class="content">
      <div class="card">
        <div class="title">{{ detail.goodsName }}</div>

        <div class="info-item">
          <div class="label">券码</div>
          <div class="codeItem" v-show="detail.cardNo">
            <div class="code">卡号：{{ detail.cardNo }}</div>
            <div
              class="copy"
              v-clipboard:copy="detail.cardNo"
              @click="copySuccess"
            >
              复制
            </div>
          </div>
          <div class="codeItem" v-show="detail.cardPwd">
            <div class="code">卡密：{{ detail.cardPwd }}</div>
            <div
              class="copy"
              v-clipboard:copy="detail.cardPwd"
              @click="copySuccess"
            >
              复制
            </div>
          </div>
          <div class="codeItem" v-show="detail.shortUrl">
            <div class="code">短链：{{ detail.shortUrl }}</div>
            <div
              class="copy"
              v-clipboard:copy="detail.shortUrl"
              @click="copySuccess"
            >
              复制
            </div>
          </div>
          <div class="codeItem" v-show="detail.verifyCode">
            <div class="code">验证码：{{ detail.verifyCode }}</div>
            <div
              class="copy"
              v-clipboard:copy="detail.verifyCode"
              @click="copySuccess"
            >
              复制
            </div>
          </div>
          <div class="codeItem" v-show="detail.redeemCode">
            <div class="code">兑换码：{{ detail.redeemCode }}</div>
            <div
              class="copy"
              v-clipboard:copy="detail.redeemCode"
              @click="copySuccess"
            >
              复制
            </div>
          </div>
        </div>

        <div class="info-item">
          <div class="label">有效期</div>
          <div class="value">有效期至: {{ detail.expireTime }}</div>
        </div>

        <div class="info-item">
          <div class="label">使用说明</div>
          <div class="value" v-html="detail.gcText"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { liaoNingDetail } from '@/api/liaoningHighway'
export default {
  name: 'meituanDetail',
  data() {
    return {
      loading: false,
      showRuleIndex: null,
      detail: {}
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      try {
        this.loading = true
        const { data } = await liaoNingDetail(this.$route.query)
        this.detail = data
        this.loading = false
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    copySuccess() {
      this.$toast({ message: '复制成功!' })
    },
    copyError() {
      this.$toast({ message: '复制失败!' })
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  background: linear-gradient(to bottom, #2d90ef 0%, #f0f0f0 40%);
  min-height: 100vh;
  .content {
    padding: 20px 15px;
    margin: 0 auto;
    .card {
      background: #fff;
      border-radius: 15px 15px 0 0;
      padding: 15px;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        bottom: -16px;
        left: 0;
        right: 0;
        height: 20px;
        background: url('~@/assets/img/liaoningHighway/botBg.png');
        background-repeat: repeat-x;
        background-size: 100%;
        z-index: 1;
      }
      .title {
        text-align: center;
        font-size: 18px;
        font-weight: bold;
        color: #333;
        margin-bottom: 20px;
        padding: 10px 10px 30px;
        border-bottom: 1px dashed #eee;
        position: relative;
        &::before {
          content: '';
          position: absolute;
          top: 54px;
          left: -26px;
          width: 18px;
          height: 18px;
          background: #71b2ef;
          border-radius: 50%;
          z-index: 1;
        }
        &::after {
          content: '';
          position: absolute;
          top: 54px;
          right: -26px;
          width: 18px;
          height: 18px;
          background: #71b2ef;
          border-radius: 50%;
          z-index: 1;
        }
      }
      .info-item {
        margin-bottom: 20px;
        .label {
          font-size: 14px;
          color: #1a1a1a;
          font-weight: 500;
          margin-bottom: 8px;
        }
        .value {
          font-size: 12px;
          color: #666;
          line-height: 1.5;
        }
        .codeItem {
          display: flex;
          font-size: 12px;
          align-items: center;
          color: #666;
          margin-bottom: 10px;
          .code {
            flex: 1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .copy {
            display: inline-block;
            width: 50px;
            line-height: 24px;
            border-radius: 12px;
            border: 1px solid #3f9ffc;
            font-size: 12px;
            color: #3f9ffc;
            text-align: center;
            margin-left: 10px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
